import React from "react";

/**
 * Scoped React error boundary for the Stripe checkout sheet.
 *
 * Any uncaught render error inside <Elements> / <PaymentElement> (bad
 * clientSecret shape, iframe mount rejected, etc.) normally unmounts the
 * entire React tree — white-screen. This boundary catches the error,
 * logs it, and hands control back to the parent via `onError(err)` so the
 * parent can transparently redirect to hosted Stripe Checkout.
 */
export default class CheckoutErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[checkout-sheet] crash inside Elements:", error, info);
    try {
      this.props.onError?.(error);
    } catch (cbErr) {
      // eslint-disable-next-line no-console
      console.error("[checkout-sheet] onError callback threw:", cbErr);
    }
  }

  render() {
    if (this.state.error) {
      // Render nothing while the parent handles the fallback. The sheet
      // already shows its own loading/error UI above this boundary.
      return this.props.fallback || null;
    }
    return this.props.children;
  }
}
